'use client';

import { useState } from 'react';
import classNames from 'classnames';
import dynamic from 'next/dynamic';
import { FormattedMessage } from 'react-intl';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import PlusLogoBadge from '@alltrails/denali/components/SubscriptionBadge/Logo/Plus';
import Typography from '@alltrails/core/components/Typography';
import cardStyles from '../CardModule/CardModule.module.scss';
import styles from './Visitation.module.scss';

const DesktopAnimation = dynamic(() => import('./VisitationChartLottie'), { ssr: false });
const MobileAnimation = dynamic(() => import('./VisitationChartMobileLottie'), { ssr: false });
const VisitationUpsellModal = dynamic(() => import('./VisitationUpsellModal'), { ssr: false });

export default function VisitationFree() {
  const isMobile = useIsMobileSizedScreen();
  const [isUpsellOpen, setIsUpsellOpen] = useState(false);

  return (
    <div className={classNames(cardStyles.card, styles.mobileWrapper)}>
      <div className={classNames(cardStyles.inner, styles.mobileInner)}>
        <div className={styles.header}>
          <Heading as="h2" size="300" className={styles.title}>
            <FormattedMessage defaultMessage="Visitation" />
          </Heading>
          <PlusLogoBadge size="md" variant="full" />
        </div>
        <div className={styles.upsellContent}>
          {isMobile ? <MobileAnimation /> : <DesktopAnimation />}
          <div className={styles.upsellText}>
            <Heading as="h3" size="300">
              <FormattedMessage defaultMessage="When is the trail busiest?" />
            </Heading>
            <Typography variant="text100" color="secondary">
              <FormattedMessage defaultMessage="Beat the crowds with weekly and monthly trail activity data" />
            </Typography>
          </div>
        </div>
        <div className={styles.upsellButtonContainer}>
          <div className={styles.upsellAction}>
            <Button
              className={styles.upsellButton}
              text={<FormattedMessage defaultMessage="Show more" />}
              variant={isMobile ? 'default' : 'elevated'}
              size="md"
              onClick={() => setIsUpsellOpen(true)}
            />
          </div>
        </div>
      </div>
      {isUpsellOpen && <VisitationUpsellModal isOpen={isUpsellOpen} onCloseRequest={() => setIsUpsellOpen(false)} />}
    </div>
  );
}
